var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRemovePost = function SvgIconRemovePost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505665",
    d: "M15.834 5.833a.833.833 0 0 0-.834.834v9.326a1.6 1.6 0 0 1-1.675 1.507h-6.65A1.6 1.6 0 0 1 5 15.992V6.668a.833.833 0 1 0-1.666 0v9.326a3.265 3.265 0 0 0 3.341 3.174h6.65a3.265 3.265 0 0 0 3.342-3.175V6.668a.834.834 0 0 0-.834-.834"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M15.834 5.833a.833.833 0 0 0-.834.834v9.326a1.6 1.6 0 0 1-1.675 1.507h-6.65A1.6 1.6 0 0 1 5 15.992V6.668a.833.833 0 1 0-1.666 0v9.326a3.265 3.265 0 0 0 3.341 3.174h6.65a3.265 3.265 0 0 0 3.342-3.175V6.668a.834.834 0 0 0-.834-.834"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M15.834 5.833a.833.833 0 0 0-.834.834v9.326a1.6 1.6 0 0 1-1.675 1.507h-6.65A1.6 1.6 0 0 1 5 15.992V6.668a.833.833 0 1 0-1.666 0v9.326a3.265 3.265 0 0 0 3.341 3.174h6.65a3.265 3.265 0 0 0 3.342-3.175V6.668a.834.834 0 0 0-.834-.834"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M15.834 5.833a.833.833 0 0 0-.834.834v9.326a1.6 1.6 0 0 1-1.675 1.507h-6.65A1.6 1.6 0 0 1 5 15.992V6.668a.833.833 0 1 0-1.666 0v9.326a3.265 3.265 0 0 0 3.341 3.174h6.65a3.265 3.265 0 0 0 3.342-3.175V6.668a.834.834 0 0 0-.834-.834"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#505665",
    d: "M16.667 3.333h-3.334V1.667A.834.834 0 0 0 12.5.833h-5a.833.833 0 0 0-.833.834v1.666H3.333a.833.833 0 0 0 0 1.667h13.334a.833.833 0 0 0 0-1.667m-8.334 0V2.5h3.334v.833z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M16.667 3.333h-3.334V1.667A.834.834 0 0 0 12.5.833h-5a.833.833 0 0 0-.833.834v1.666H3.333a.833.833 0 0 0 0 1.667h13.334a.833.833 0 0 0 0-1.667m-8.334 0V2.5h3.334v.833z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M16.667 3.333h-3.334V1.667A.834.834 0 0 0 12.5.833h-5a.833.833 0 0 0-.833.834v1.666H3.333a.833.833 0 0 0 0 1.667h13.334a.833.833 0 0 0 0-1.667m-8.334 0V2.5h3.334v.833z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M16.667 3.333h-3.334V1.667A.834.834 0 0 0 12.5.833h-5a.833.833 0 0 0-.833.834v1.666H3.333a.833.833 0 0 0 0 1.667h13.334a.833.833 0 0 0 0-1.667m-8.334 0V2.5h3.334v.833z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#505665",
    d: "M9.167 14.167V8.333a.833.833 0 0 0-1.667 0v5.834a.833.833 0 0 0 1.667 0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M9.167 14.167V8.333a.833.833 0 0 0-1.667 0v5.834a.833.833 0 0 0 1.667 0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M9.167 14.167V8.333a.833.833 0 0 0-1.667 0v5.834a.833.833 0 0 0 1.667 0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M9.167 14.167V8.333a.833.833 0 0 0-1.667 0v5.834a.833.833 0 0 0 1.667 0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#505665",
    d: "M12.5 14.167V8.333a.833.833 0 1 0-1.666 0v5.834a.833.833 0 0 0 1.666 0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M12.5 14.167V8.333a.833.833 0 1 0-1.666 0v5.834a.833.833 0 0 0 1.666 0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M12.5 14.167V8.333a.833.833 0 1 0-1.666 0v5.834a.833.833 0 0 0 1.666 0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M12.5 14.167V8.333a.833.833 0 1 0-1.666 0v5.834a.833.833 0 0 0 1.666 0"
  })));
};
export default SvgIconRemovePost;